export class SureFlowRatingCoilRequest {

  id!: number;
  enteringDryBulb!: number;
  enteringWetBulb!: number;
  rowCount!: number;
  temperatureChange!: number;
  flowRate!: number;
  fluidType!: string;
  enteringFluidTemperature!: number;
  electricHeatKilowatts!: number;
  electricHeatVoltage!: string;
  glycolPercentage!: number;
  isCooling!: boolean;
  isElectricHeat!: boolean;

}
